import {Component,Input,Output,OnInit,OnChanges,ViewChild,EventEmitter, AfterViewInit,
    ChangeDetectionStrategy, ChangeDetectorRef, Renderer, ElementRef, forwardRef} from '@angular/core';
import {Pipe, PipeTransform} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {Subscription} from 'rxjs/Subscription';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/throttleTime';
import 'rxjs/add/observable/fromEvent';
import 'rxjs/add/operator/distinctUntilChanged';

@Component({
    selector: 'tri-state-checkbox',
    template: `<input #theCheckbox type="checkbox" [(ngModel)]="topLevel" (change)="topLevelChange()">`
})

export class TristateCheckbox implements AfterViewInit, OnChanges  {
  public topLevel: boolean = false;
  public _items: Array<any>;
  private _subscription: Subscription;
  @Input() items: Observable<any[]>;
  @ViewChild("theCheckbox") checkbox;
  
  constructor(private _changeDetectorRef: ChangeDetectorRef) { }
    
  private setState() {
    if (!this._items) return;
    var count: number = 0;
    for (var i: number = 0; i < this._items.length; i++) {
      count += this._items[i].isSelected ? 1 : 0;
    }
    this.topLevel = (count === 0) ? false : true;
    if (count > 0 && count< i) {
      console.log("Setting indeterminate.");
      this.checkbox.nativeElement.indeterminate = true;
    } else {
      console.log("Removing indeterminate.");
      this.checkbox.nativeElement.indeterminate = false;
    }
  }
  ngOnChanges(changes: any) {
    // changes.prop contains the old and the new value...
    this.setState();
  }
//   ngDoCheck() {
//     this.setState();
//   }
  
  public topLevelChange() {
    console.log("Clicked. " + this.topLevel);
    for (var i: number = 0; i < this._items.length; i++) {
      this._items[i].isSelected = this.topLevel;
    }
  }
  
  ngOnInit() { }
  
  ngAfterViewInit() {
    this._subscription = this.items.subscribe(res => {
      console.log("Subscription triggered.");
      this._items = res;
      this.setState();
      this._changeDetectorRef.detectChanges();
    });
  }
}




// WEBPACK FOOTER //
// /Users/brianyoung/Documents/Development/hfg/datalive-core/gae-web/datalive/client/src/app/shared/components/tristate-checkbox/tristate-checkbox.component.ts